import InputStyles from '../ParamsAndConstrainsts.module.scss'
import Styles from './ConstraintsForm.module.scss'
import FeatherIcon from 'feather-icons-react';
import { useTranslation } from 'components/lib';

export function ConstraintsForm({ parameters, selectFunction, index, constraints, deleteConstraints, addNewClause, removeClause }) {

    const { t } = useTranslation();

    return (
        <div className={Styles.main_container}>
            <span style={{ display: 'flex', alignItems: 'center', gap: '0.5em' }}>
                <select
                    className={`${InputStyles.parmaInput} ${Styles.selectComponent}`}
                    onChange={(e) => { selectFunction('type', e.target.value, index) }}
                    value={constraints.type}
                >
                    <option value="">{t('Components.NodeLayout.CombinatorialTestPane.constraintForm.selectCondition')}</option>
                    <option value="IF">if</option>
                    <option value="always together">always together</option>
                </select>
                <button title={t('Components.NodeLayout.CombinatorialTestPane.constraintForm.deleteConstraint')}><FeatherIcon size='1.1em' icon='x' role='button' onClick={() => { deleteConstraints(index) }} /></button>
            </span>

            <span className={Styles.constraintConditionsContainer}>
                {constraints.secs.map((constr, constIndex) => (
                    <span key={`secs_${constIndex}`} className={Styles.constraintConditions}>

                        {/* param */}
                        {'param' in constr && <select
                            className={`${InputStyles.parmaInput} ${Styles.selectComponent}`}
                            onChange={(e) => { selectFunction('param', e.target.value, index, constIndex) }}
                            value={constr.param}
                        >
                            <option value="">{t('Components.NodeLayout.CombinatorialTestPane.constraintForm.selectParam')}</option>
                            {
                                parameters.map((keys, index) => (
                                    <option key={`key1_${index}`} value={keys?.keys}>{keys.key}</option>
                                ))
                            }
                        </select>}

                        {/* bind */}
                        {'bind' in constr && <select
                            className={`${InputStyles.parmaInput} ${Styles.selectComponent}`}
                            onChange={(e) => { selectFunction('bind', e.target.value, index, constIndex) }}
                            value={constr.bind}
                        >
                            <option value=""></option>
                            <option value="=">is</option>
                            <option value="<>">is not</option>
                        </select>}

                        {/* value */}
                        {'value' in constr && <select
                            className={`${InputStyles.parmaInput} ${Styles.selectComponent}`}
                            onChange={(e) => { selectFunction('value', e.target.value, index, constIndex) }}
                            value={constr.value}
                        >
                            <option value="">{t('Components.NodeLayout.CombinatorialTestPane.constraintForm.selectValue')}</option>
                            {
                                parameters.filter(p => p.key === constr.param).map((param, index) => (
                                    param.values.map((val, valIndex) => (
                                        <option key={`value1_${valIndex}`} value={val}>{val}</option>
                                    ))
                                ))


                            }
                        </select>}
                        {'between' in constr && <select
                            className={`${InputStyles.parmaInput} ${Styles.selectComponent}`}
                            onChange={(e) => { selectFunction('between', e.target.value, index, constIndex) }}
                            value={constr.between}
                        >
                            <option value=""></option>
                            <option value="AND">and</option>
                            <option value="OR">or</option>
                            <option value="THEN">then</option>
                            <option value="with">with</option>
                        </select>}
                        <span style={{ display: 'flex', alignItems: 'center', gap: '0.5em' }}>
                            <button title={t('Components.NodeLayout.CombinatorialTestPane.constraintForm.button.addClause')}><FeatherIcon icon='plus-circle' size='1.1em' color='green' role='button' onClick={() => { addNewClause(index, constIndex) }} /></button>
                            <button title={t('Components.NodeLayout.CombinatorialTestPane.constraintForm.button.deleteClause')}><FeatherIcon icon='x' size='1.1em' color='black' role='button' onClick={() => { removeClause(index, constIndex) }} /></button>
                        </span>
                    </span>
                ))}

            </span>
        </div>
    )
}
